import React, { useEffect, useRef, useState } from "react";
import "./../../../assets/css/student/Trustedmentors/Trustedmentors.css";


const mentors = [
  {
    id: 1,
    name: "Ahmed Raza",
    subject: "Python",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=11",
    learners: "50",
    rating: 5,
  },
  {
    id: 2,
    name: "Usman Ali",
    subject: "Web Development",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=12",
    learners: "80",
    rating: 4,
  },
  {
    id: 3,
    name: "Fatima Malik",
    subject: "React.js",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=9",
    learners: "50",
    rating: 5,
  },
  {
    id: 4,
    name: "Bilal Khan",
    subject: "Data Structure",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=15",
    learners: "62",
    rating: 4,
  },
  {
    id: 5,
    name: "Ayesha Siddiqui",
    subject: "HTML&CSS",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=5",
    learners: "72",
    rating: 5,
  },
  {
    id: 6,
    name: "Hassan Nawaz",
    subject: "App development",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=47",
    learners: "56",
    rating: 4,
  },
];


const Stars = ({ count }) => (
  <div className="mtm-stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <span key={s} className={s <= count ? "mtm-star filled" : "mtm-star"}>★</span>
    ))}
  </div>
);

const MostTrustedMentors = () => {
  const trackRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const perRow   = 3; // cards per row
  const rows     = 2;
  const perSlide = perRow * rows; // 6 total, so 1 slide
  const totalSlides = Math.ceil(mentors.length / perRow); // rows of 3

  // For this layout: slide by 1 row (3 cards) at a time
  const [rowOffset, setRowOffset] = useState(0);
  const totalRows = Math.ceil(mentors.length / perRow); // 2

  const prevRow = () => setRowOffset((r) => Math.max(0, r - 1));
  const nextRow = () => setRowOffset((r) => Math.min(totalRows - rows, r + 1));

  // Auto-cycle
  useEffect(() => {
    const id = setInterval(() => {
      setRowOffset((r) => (r >= totalRows - rows ? 0 : r + 1));
    }, 4500);
    return () => clearInterval(id);
  }, [totalRows, rows]);

  // Visible mentors: always show perRow * rows = 6
  // For slider effect: slide through rows
  useEffect(() => {
    if (!trackRef.current) return;
    const rowH = 180 + 24; // card height + gap
    trackRef.current.style.transform = `translateY(-${rowOffset * rowH}px)`;
  }, [rowOffset]);

  return (
    <section className="mtm-section">
      {/* Background blobs */}
      <div className="mtm-blob mtm-blob1" />
      <div className="mtm-blob mtm-blob2" />

      <div className="mtm-container">

        {/* ── HEADING ── */}
        <div className="mtm-heading">
          <div className="mtm-tag">🏆 Top Mentors</div>
          <h2 className="mtm-title">
            Most <span className="mtm-accent">Trusted</span> Companion
          </h2>
          <p className="mtm-sub">Chosen by thousands of learners worldwide</p>
        </div>

        {/* ── GRID SLIDER ── */}
        <div className="mtm-slider-outer">
          <div className="mtm-track-wrap">
            <div className="mtm-track" ref={trackRef}>
              {/* Row 1 */}
              <div className="mtm-row">
                {mentors.slice(0, 3).map((m) => (
                  <MentorCard key={m.id} mentor={m} />
                ))}
              </div>
              {/* Row 2 */}
              <div className="mtm-row">
                {mentors.slice(3, 6).map((m) => (
                  <MentorCard key={m.id} mentor={m} />
                ))}
              </div>
            </div>
          </div>

          {/* Side arrows */}
          <button className="mtm-arrow mtm-arrow-left" onClick={prevRow} disabled={rowOffset === 0}>
            ↑
          </button>
          <button className="mtm-arrow mtm-arrow-right" onClick={nextRow} disabled={rowOffset >= totalRows - rows}>
            ↓
          </button>
        </div>

        {/* Dots */}
        <div className="mtm-dots">
          {Array.from({ length: totalRows - rows + 1 }).map((_, i) => (
            <button
              key={i}
              className={`mtm-dot ${rowOffset === i ? "mtm-dot-active" : ""}`}
              onClick={() => setRowOffset(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

const MentorCard = ({ mentor }) => (
  <div className="mtm-card">
    <div className="mtm-card-left">
      <img src={mentor.image} alt={mentor.name} className="mtm-avatar" />
    </div>
    <div className="mtm-card-right">
      <p className="mtm-name">{mentor.name}</p>
      <div className="mtm-meta">
        <span className="mtm-subject">{mentor.subject}</span>
        <span className="mtm-country">{mentor.country}</span>
      </div>
      <p className="mtm-learners">
        <span className="mtm-learners-count">{mentor.learners} learners</span>
      </p>
      <Stars count={mentor.rating} />
    </div>
  </div>
);

export default MostTrustedMentors;